export enum ImageKey {
  Logo = "logo_url",
  Photo = "agent_photo_url",
}

export interface PayPerLeadBuyerFiles {
  [ImageKey.Logo]: File | null;
  [ImageKey.Photo]: File | null;
}

export interface PayPerLeadBuyerImages {
  [ImageKey.Logo]: string | null;
  [ImageKey.Photo]: string | null;
}

export interface PayPerLeadBuyerProfile {
  id: number;
  account_id: number;
  name: string;
  [ImageKey.Logo]?: string | null;
  agent_name?: string | null;
  [ImageKey.Photo]?: string | null;
  agent_email?: string | null;
  agent_phone?: string | null;
  created_at?: Date;
  updated_at?: Date | null;
  created_by?: string;
  updated_by?: string | null;
}

export interface PayPerLeadBuyerProfilePayload {
  account_id: number;
  buyerProfile: Partial<PayPerLeadBuyerProfile>;
  files: PayPerLeadBuyerFiles;
}
